export default `
<button ng-show="!isLoading && feedItems.length >= 10" class="back-to-top" ng-class="{'back-to-top--push-down': isLastPage}" ng-click="scrollToTop()">
  Back to top <i class="icon-arrowUp"></i>
</button>
`;
